/**
 * Opt in locally with VITE_DMP_CHAT_SIGNALR_TRACE=true.
 * import.meta.env.DEV keeps the trace unavailable in production builds.
 */
export const DMP_CHAT_SIGNALR_TRACE_ENABLED: boolean =
  import.meta.env.MODE === 'development' && import.meta.env.VITE_DMP_CHAT_SIGNALR_TRACE === 'true'
